import { createApp } from 'vue';
import yotpoReviews from '../../../vue/yotpo-reviews/yotpo-reviews.vue';

if (document.getElementById('vue-yotpo-reviews')) {
  const props = {
    productId: productIdForReviews,
    productUrl: productUrl,
    productTitle: productTitle,
    productType: productType,
    productTags: productTags,
  };
  createApp(yotpoReviews, props).mount('#vue-yotpo-reviews');
}
